import { createEffect, createStore } from 'effector';
import type {
  FeatureFlags,
  ModuleId,
  TenantBranding,
  TenantConfig,
  TenantInfo,
} from '@buildex/module-contract';
import { apiClient } from '../api/client';
import { brandingPreviewReceived } from '../preview/branding-preview';

/** Фолбэк до загрузки конфига (совпадает с DEFAULT_BRANDING в theme) */
const FALLBACK_BRANDING: TenantBranding = {
  logoUrl: '',
  primaryColor: '#1971c2',
  colorScheme: 'light',
  radius: 'md',
};

// --- эффекты -----------------------------------------------------------

export const fetchTenantConfigFx = createEffect<void, TenantConfig, Error>(() =>
  apiClient.get<TenantConfig>('/tenant/config'),
);

// --- сторы -------------------------------------------------------------

export const $tenantConfig = createStore<TenantConfig | null>(null).on(
  fetchTenantConfigFx.doneData,
  (_, config) => config,
);

export const $tenant = $tenantConfig.map<TenantInfo | null>((c) => c?.tenant ?? null);

export const $activeModules = $tenantConfig.map<ModuleId[]>((c) => c?.modules ?? []);

/**
 * Единый стор брендинга: конфиг тенанта + live-превью из админки.
 * TenantThemeProvider (theme) подписан на него → смена применяется мгновенно.
 */
export const $branding = createStore<TenantBranding>(FALLBACK_BRANDING)
  .on(fetchTenantConfigFx.doneData, (_, config) => config.branding)
  .on(brandingPreviewReceived, (_, branding) => branding);

export const $featureFlags = createStore<FeatureFlags>({}).on(
  fetchTenantConfigFx.doneData,
  (_, config) => config.featureFlags,
);
